<template>
    <div class="next SubAgent">
        <div class="title">
            <span> {{$t('my.proxy.SubAgent')}} </span>
            <div class="fixed" @click="gaBack">
                <svg t="1658129167849" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="12456" width="0.3rem" height="0.3rem">
                    <path
                        d="M245.01248 555.52512l447.0784 447.0784c22.42048 22.42048 58.81856 22.42048 81.31584 0 22.42048-22.42048 22.42048-58.81856 0-81.31584l-406.49216-406.4256 406.49728-406.49216c22.42048-22.42048 22.42048-58.81856 0-81.31584-22.42048-22.42048-58.81856-22.42048-81.31584 0L244.9408 474.20928c-22.43584 22.47168-22.40512 58.88 0.07168 81.31584 0-0.00512 0 0 0 0z"
                        fill="#666666" p-id="12457"></path>
                </svg>
            </div>
            <div class="title_ellipsis">
                <img @click="topsearchBox=!topsearchBox" src="../../../assets/img/topSearch.png" />
            </div>

            <div class="cardsTab">
                <ul class="flexCenter">
                    <!-- active=1 -->
                    <li :class="{'active': active==1 }" @click="changeActive(1)">{{$t('my.proxy.level1Agent')}}</li>
                    <li :class="{'active': active==2 }" @click="changeActive(2)">{{$t('my.proxy.level2Agent')}}</li>
                </ul>
            </div>

            <div v-show="topsearchBox" class="searchBox">
                <van-cell-group v-show="active==2" inset>
                    <van-field v-model.trim="nextMemberID" @keyup="nextMemberID=nextMemberID.replace(/[^\d]/g,'')" :placeholder="`${$t('my.proxy.level2AgentIDTips')}`" autocomplete="off" />
                </van-cell-group>
                <van-cell-group inset>
                    <van-field v-model.trim="value" @keyup="value=value.replace(/[^\d]/g,'')" :placeholder="`${$t('my.proxy.level1AgentIDTips')}`" autocomplete="off" />
                </van-cell-group>
                <van-dropdown-menu class="betSearch">
                    <van-dropdown-item active-color="#6996FF" ref="searchItemDay">
                        <template v-slot:title>
                            <van-cell-group inset>
                                <van-field v-model="dateShow" autocomplete="off" :right-icon="require('../../../assets/img/select.png')"  @click="showDateBox=true"
                                :placeholder="`${$t('my.proxy.selectTime')}`" />
                            </van-cell-group>
                        </template>

                        <div class="customizeSearchBox">
                            <div class="customizeSearch borderBottom">
                                <div @click="showStartDate=!showStartDate,showEndDate=false"
                                    class="customizeSearchItem flexBetween">
                                    <div> {{$t('my.proxy.startDate')}}</div>
                                    <div>{{ getDate(currentStartDate) }}
                                        <van-icon name="arrow" />
                                    </div>
                                </div>

                                <div v-show="showStartDate">
                                    <van-datetime-picker item-height="0.6rem" v-model="currentStartDate"
                                        :show-toolbar="false" type="date" :title="`${'my.proxy.selectDateTips'}`"
                                        :max-date="maxDate" />
                                </div>
                            </div>

                            <div class="customizeSearch">
                                <div @click="showEndDate=!showEndDate,showStartDate=false"
                                    class="customizeSearchItem flexBetween">
                                    <div>{{$t('my.proxy.endDate')}}</div>
                                    <div>{{ getDate(currentEndDate) }}
                                        <van-icon name="arrow" />
                                    </div>
                                </div>

                                <div v-show="showEndDate">
                                    <van-datetime-picker item-height="0.6rem" v-model="currentEndDate"
                                        :show-toolbar="false" type="date" :title="`${'my.proxy.selectDateTips'}`"
                                        :max-date="maxDate" />
                                </div>
                            </div>

                            <div class="customizeBtnBox">
                                <div @click="cancelSearch" class="customizeBtnCancel">{{$t('common.cancel')}}</div>
                                <div @click="goSearch" class="customizeBtnConfirm">{{$t('common.sure')}}</div>
                            </div>
                        </div>
                    </van-dropdown-item>
                </van-dropdown-menu>

                <div class="searchBtnBox flexCenter">
                    <div @click="resetSearch" class="confirmBtn borderRound">{{$t('common.reset')}}</div>
                    <div @click="comfigSearch" class="confirmBtn hasValue">{{$t('my.proxy.filter')}}</div>
                </div>

            </div>
        </div>

        <div class="exchangeData">
            <div v-show="active==1" class="tableTitle">
                {{$t('my.proxy.level1AgentNum')}}： {{ totalBelowFee }}
            </div>
            <div v-show="active==2" class="tableTitle">
                {{$t('my.proxy.level2AgentNum')}}： {{ totalBelowFee }}
            </div>
            <div class="tableItem tableHead flexBetween">
                <div>{{$t('my.proxy.subAgentReportTable.agentID')}}</div>
                <div v-show="active==1">{{$t('my.proxy.level2AgentNum')}}</div>
                <div v-show="active==2">{{$t('my.proxy.level1AgentID')}}</div>
                <div>{{$t('my.proxy.downlineMember')}}</div>
            </div>
            <div v-if="tableList.length>0">
                <van-pull-refresh v-model="isLoading" :disabled="isRefreshDisable" @refresh="onRefresh">
                    <template #pulling>
                        <van-loading />
                    </template>

                    <!-- 释放提示 -->
                    <template #loosing>
                        <van-loading />
                    </template>

                    <!-- 加载提示 -->
                    <template #loading>
                        <van-loading />
                    </template>
                    <!-- finished // 是否已加载完成，加载完成后不再触发load事件
                        offset // 滚动条与底部距离小于offset时触发load事件
                        immediate-check // 是否在初始化时立即执行滚动位置检查
                        onLoad  // 滚动条与底部距离小于offset时触发onLoad()
                        :immediate-check="flase" 
                    -->
                    <van-list
                        class="vanList"
                        v-model="loading"
                        :finished="finished"
                        style="height:calc(100vh - 4.1rem);overflow:scroll;"
                        :offset="10" 
                        :immediate-check="check" 
                        :finish-text="`${$t('lottery.noMore')}`"
                        @load="onLoad" 
                        >
                            <div v-for="(item, index) in tableList" :key="`${index}--tableList`" class="tableItemBox">
                                <div class="flexBetween tableItem">
                                    <div>{{item.belowUid}}</div>
                                    <div>
                                        <p v-show="active==1">{{item.belowNum}}</p>
                                        <p v-show="active==2">{{item.parentUid}}</p>
                                    </div>
                                    <div class="flexBetweenTop" v-show="active==1" @click="goNextTab(item)">
                                        <p>{{item.userNum}}</p>
                                        <van-icon  name="arrow" />
                                    </div>
                                    <div class="flexBetweenTop" v-show="active==2">
                                        <p>{{item.userNum}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="showAll" v-show="finished"> {{$t('lottery.showAll')}} </div>
                    </van-list>
                </van-pull-refresh>
            </div>

            <div v-else class="noData">
                <img src="../../../assets/img/record/noData.png"/>
                <p>{{$t('common.noData')}}</p>
            </div>
        </div>

    </div>
</template>

<script>
import { queryProxyBelowList } from "@/api/proxy";
import moment from "moment";
import utils from "@/utils/index";
export default {
    data() {
        return {
            value: "",
            nextMemberID: "",
            dateShow: "", //月份
            tableList: [],
            maxDate: new Date(),
            currentStartDate: new Date(),
            currentEndDate: new Date(),
            topsearchBox: false, //搜索条件是否展示
            rightIcon: require('../../../assets/img/select.png'), 
            arrMonth: [], //月份列表
            page: 0,
            showMonth: false,
            actvieMonth: 0,
            isLoading: false,
            isRefreshDisable: false,
            finished: true,
            check: false, //是否开始就检查
            loading: false,
            totalBelowFee: 0, //总佣金抽成
            active: 1,
            maxDate: new Date(),
            currentStartDate: new Date(),
            currentEndDate: new Date(),
            showStartDate: false,
            showEndDate: false,
            showDateBox: false, // 显示时间选择
            dateShow: "", //用来展示时间的字段
            isNeedTime: false, // 参数是否传参 时间
            scrollTop: 0, //滚动的距离
        }
    },
    watch: {
        scrollTop(newval) {
            if (newval > 0) {
                this.isRefreshDisable = true
            } else {
                this.isRefreshDisable = false
            }
        }
    },
    computed: {
        member() {
            return this.$store.state.member;
        },
    },
    created() {
        this.getList();
    },
    methods: {
        // 重置
        resetSearch() {
            this.value = "";
            this.nextMemberID = "";
            this.dateShow = "";
            this.isNeedTime = false;
            this.finished = true;
        },
        // tab切换
        changeActive(num) {
            this.active = num;
            this.page = 0;
            this.topsearchBox = false;
            this.resetSearch();
            this.getList();
        },
        goNextTab(item) {
            this.value = item.belowUid;
            this.nextMemberID = "";
            this.dateShow = "";
            this.isNeedTime = false;
            this.finished = true;
            this.active = 2;
            this.page = 0;
            this.topsearchBox = false;
            this.getList();
        },
        getTime(val) {
            if (val) {
                return moment(val).format('HH:mm:ss');
            }

            return "--";
        },
        getDate(val) {
            if (val) {
                return moment(val).format('YYYY-MM-DD');
            }

            return "--";
        },
        // 时间确定
        goSearch() {
            this.isNeedTime = true;
            this.$refs.searchItemDay.toggle();
            this.page = 0;
            this.dateShow = this.getDate(this.currentStartDate) + '/' + this.getDate(this.currentEndDate);
        },
        cancelSearch() {
            this.$refs.searchItemDay.toggle();
        },
        // onLoad 加载更多
        onLoad() {
            if (!this.finished) {
                this.loading = true;
                this.page ++;
                this.getList();
            }
        },
        onRefresh() {
            setTimeout(() => {
                this.page = 0;
                this.getList(true);
            }, 1000);
        },
        //筛选 
        comfigSearch() {
            this.page = 0;
            this.getList();
        },
        gaBack() {
            this.$router.push(`/mine/myProxy`);
        },
        /**
         * @description: 下拉刷新和滚动事件冲突
         * @param {*}
         * @return {*}
         */
        resolveConflict(val) {
            const vantList = val;
            vantList.addEventListener('touchmove', () => {
                this.scrollTop = vantList.scrollTop
            }, { passive: true});
            vantList.addEventListener('touchend', () => {
                this.scrollTop = vantList.scrollTop
            }, { passive: true});
        },
        // 获取列表数据
        getList(refresh) {
            let params = {
                uid: this.member.uid,
                page: this.page,
                pageSize: 20,
                belowLevel: this.active,
                oneBelowUid: this.value
            }

            if (this.isNeedTime) {
                params.startTime = utils.timeforamt(this.currentStartDate);
                params.endTime = utils.timeforamt(this.currentEndDate, "end");
            }

            if (this.active==2) {
                params.twoBelowUid = this.nextMemberID;
            }

            if (!this.page) {
                this.tableList = [];
            }
            this.loading = true;
            this.finished = true;
            queryProxyBelowList(params).then(res => {
                if (res.code == 0) {
                    let dataArr = JSON.parse(JSON.stringify(res.data.proxyBelowListList));
                    this.totalBelowFee = res.data.totalNum;
                    dataArr.forEach(item => {
                        item.falg = false;
                    });

                    if (!params.page) {
                        this.tableList = dataArr;
                    } else {
                        if (res.data.proxyBelowListList.length > 0) {
                        let arr = JSON.parse(JSON.stringify(this.tableList));
                        arr = [...dataArr, ...arr];
                            this.tableList = arr;
                        }
                    }

                    if (res.data.proxyBelowListList.length == 20) {
                        this.finished = false;
                    } else {
                        this.finished = true;
                    }

                    if (refresh) {
                        this.$toast(this.$t('common.refreshSuccess'));
                    }
                    // 解决滚动条与下拉的冲突  数据没回来之前获取不到dom
                    setTimeout(() => {
                        const vantList = document.querySelector('.van-list');
                        if (vantList) {
                            this.resolveConflict(vantList);
                        }
                    }, 10);
                } else {
                    if (res.msg) this.$toast(res.msg);
                    this.totalBelowFee = 0;
                }
                this.topsearchBox = false;
                this.loading = false;
            }).catch(err => {
                this.topsearchBox = false;
                this.loading = false;
                this.totalBelowFee = 0;
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.SubAgent {
    padding-top: 2.3rem;
    .title {
        .title_ellipsis {
            img {
                width: 0.4rem;
            }
        }

        .cardsTab {
            padding: 0.28rem;
            background: #fff;

            ul {
                -webkit-flex-flow: row nowrap;
                flex-flow: row nowrap;
                background: #EBEFF1;
                border-radius: 0.16rem;
                padding: 0.02rem;

                li {
                    flex: 1 1;
                    text-align: center;
                    line-height: 0.58rem;
                    height: 0.58rem;
                    color: #bbb;
                    font-family: PingFang SC;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.27rem;
                    margin: 0.02rem;

                    &.active {
                        background: #fff;
                        border-radius: 0.16rem;
                        color: #333;
                    }
                }
            }
        }
    }

    .searchBtnBox {
        margin: 0 0.28rem;

        .confirmBtn.borderRound {
            background: #fff !important;
            border: 1px solid #eb457e !important;
            color: #eb457e;
        }
    }

    .exchangeData {
        height: calc(100vh - 3.3rem);
        .tableTitle {
            text-align: left;
            padding: 0 0.28rem;
            height: 0.88rem;
            line-height: 0.88rem;
            color: #333;
            font-weight: 500;
            background-color: #fff;
            font-size: 0.32rem;
        }

        .tableItemBox {
            background-color: #fff;

            &:nth-child(odd) {
                background-color: #F9F9F9;
            }

            &:first-child {
                border-bottom: none;
            }

            .tableItemMore {
                text-align: left;
                padding: 0 0.28rem 0.4rem;

                p {
                    margin-top: 0.28rem;
                }
            }
        }
        .tableItem {
            border-bottom: 1px solid #EBEFF1;
            padding: 0 0.28rem;
            height: 0.88rem;
            color: #626872;

            &.tableHead {
                color: #333;
                background-color: #E5E5E5 !important;
            }

            div {
                flex: 1;
                text-align: left;
                font-size: 0.24rem;

                i {
                    color: #788597;
                    margin-left: 0.1rem;
                }
            }
        }
    }

    .customizeBtnBox {
      display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */
      display: -moz-box; /* Firefox 17- */
      display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */
      display: -moz-flex; /* Firefox 18+ */
      display: -ms-flexbox; /* IE 10 */
      display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */

      div {
        width: 50%;
        height: 0.9rem;
        line-height: .9rem;
        text-align: center;
        font-size: .32rem;
      }

      .customizeBtnCancel {
        color: #F74995;
        background-color: #fff;
      }

      .customizeBtnConfirm {
        background-color: #F74995;
        color: #fff;
      }
    }

    .showAll {
      font-size: 0.24rem;
      color: #626872;
      text-align: center;
      height: 0.8rem;
      line-height: 0.8rem;
    }
}

.bankListCont {
    margin-bottom: 0.3rem;
    min-height: 6rem;

    .bankListCont_item {
        padding: 0.36rem 0;
        margin: 0 0.28rem;
        border-bottom: 1px solid #EBEFF1;

        &:last-child {
            border-color: transparent;
        }

        .bankListCont_item_left {
            text-align: left;
            color: #626872;
            font-size: 0.2rem;

            img {
                width: 0.64rem;
                height: 0.64rem;
                margin-right: 0.1rem;
            }

            p:first-child {
                font-size: 0.28rem;
                color: #333;
                font-weight: bold;
                margin-bottom: 0.05rem;
            }
        }
    }
}
</style>

<style lang="scss">
.SubAgent {
    padding-top: 2.3rem;
    .searchBox {
        background-color: #fff;
        padding-bottom: 0.2rem;
        box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.03);

        .confirmBtn {
            margin: 0 auto;
            width: calc(50% - 0.2rem);
            border-radius: 0.1rem;
        }

        .van-cell-group {
            border: 1px solid #f2f2f2;
            margin-bottom: 0.2rem;
        }
    }

    .betSearch {
        .van-dropdown-menu__bar {
            box-shadow: 0 0 0 0 rgb(0, 0, 0, 0) !important;
        }
        
        .van-dropdown-menu__title {
            width: 100%;
            padding: 0 !important;

            &:after {
                border-width: 0 !important;
            }
        }

        .customizeSearch {
            font-size: 0.28rem;
            position: relative;
            z-index: 2;

            &.borderBottom {
                border-bottom: 1px solid #ebeff1;
            }

            .customizeSearchItem {
                padding: 0.04rem 0.28rem;
                text-align: left;
            }
        }
    }
}
</style>